// import { parseCookies } from "nookies";
// import React from "react";
// import { Route, Navigate ,Routes} from "react-router-dom";

// const PrivateRoute = ({ component: Component, ...rest }) => {
//   const cookies = parseCookies();
//   const token = cookies?.token;

//   return (
//     <Routes>
//       <Route
//         {...rest}
//         render={(props) => (token ? <Component {...props} /> : Navigate("/"))}
//       />
//     </Routes>
//   );
// };
// export default PrivateRoute;

import { Navigate } from "react-router-dom";

import { parseCookies } from "nookies";
import Dashboard from "./pages/index";
import Editors from "./pages/editors/Editors";
import Analytics from "./pages/analytics/Analytics";
import CopyWriters from "./pages/copywriters";
import Releasevideo from "./pages/releasevideo/Release-video";
import Notification from "./pages/notification";
import Members from "./pages/members";
import PendingTitling from "./pages/pending-titling";
import PendingPublication from "./pages/pending-publication";
import Managers from "./pages/managers";
import Message from "./pages/message";
import Published from "./pages/published";
import Pending from "./pages/SubmitedVideos/pending";
import Inquiring from "./pages/SubmitedVideos/inquring";
import Approved from "./pages/SubmitedVideos/approved";
import Website from "./pages/SubmitedVideos/website";
import Duplications from "./pages/SubmitedVideos/duplications";
import Rejected from "./pages/SubmitedVideos/rejected";
import Deleted from "./pages/SubmitedVideos/deleted";
import Myaccount from "./pages/Myaccount/Myaccount";
import Hubuser from "./pages/hubuser/Hubuser";
import QcAgents from "./pages/qc-agents/Qc-Agents";
import Partner from "./pages/partners/Partner";
import Support from "./pages/support/Support";
import BuyersList from "./pages/buyers-list/BuyersList";
import PurchaseRequest from "./pages/purchase-requests/PurachaseRequest";
import VideoPage from "./pages/user/QcagentDashboard/AwaitingConfirmation/VideoPage";
import PendingVideo from "./components/VideoPages/pages/PendingVideo";
import DeletedVideo from "./components/VideoPages/pages/DeletedVideo";
import MessageDetails from "./pages/message-details/MessageDetails";
import SupportDetails from "./pages/support-details/SupportDetails";
import PurchaseRequestDetails from "./pages/purchase-request-details/PurchaseRequestDetails";
import VideoDetails from "./components/VideoPages/components/VideoDetails";
import VideoDetailsPage from "./components/VideoPages/pages/VideoDetailsPage";
import ManagerDashboard from "./pages/user/ManagerDashboard/ManagerDashboard";
import MyAccountManager from "./pages/user/ManagerDashboard/MyAccount";
import MyMessage from "./pages/user/ManagerDashboard/MyMessage/MyMessage";
import { default as ManagerMessageDetails } from "./pages/user/ManagerDashboard/MyMessage/MessageDetails";
import { default as ManagerSearchResult } from "./pages/user/ManagerDashboard/SearchResult";
import EditorDashboard from "./pages/user/EditorDashboard/EditorDashboard";
import CopywriterDashboard from "./pages/user/CopywriterDashboard/CopywriterDashboard";
import ContentBuyerDashboard from "./pages/user/content-buyer/ContentBuyerDashboard";
import QcagentDasboard from "./pages/user/QcagentDashboard/QcagentDasboard";
import MemberPartnerDashboard from "./pages/user/MemberPartnerDashboard/MemberPartnerDashboard";
import CopyWriterMyAccount from "./pages/user/CopywriterDashboard/CopyWriterMyAccount";
import CopywriterCompleteVideos from "./pages/user/CopywriterDashboard/complete-videos/CopywriterCompleteVideos";
import PendingTitlingPage from "./pages/user/CopywriterDashboard/pending-titling/pendingTitlingPage";
import PendingTitlingCopyWriters from "./pages/user/CopywriterDashboard/pending-titling/PendingTitling";
import PendingTitlingRevised from "./pages/user/CopywriterDashboard/pending-titling/pending-titling-revised";
import CopywriterSearchResult from "./pages/user/CopywriterDashboard/CopywriterSearchResult";
import EditorSearchResult from "./pages/user/EditorDashboard/EditorSearchResult";
import QcSearchVideoPage from "./pages/QcSearch/QcSearchVideoPage";

export function PrivateRoute({ children }) {
  const cookies = parseCookies();
  const token = cookies?.token;

  // console.log("savedrole_Id", savedrole_Id);
  // const token1 = cookies?.yourCookieName;

  return token != null ? children : <Navigate to="/login" />;
}
const cookies = parseCookies();

const savedrole_Id = cookies?.role_id;
// console.log("role_id", savedrole_Id);

export const PrivateRoutes = [
  {
    route: "/analytics",
    component: <Analytics />,

    // !!savedrole_Id &&( savedrole_Id == 1 ? <Analytics /> :  <Navigate to="/page404" /> ),
  },
  {
    route: "/",
    component: <Dashboard />,

    // !!savedrole_Id && (savedrole_Id == 1 ? <Dashboard /> : <Navigate to="/page404" />),
  },
  {
    route: "/copywriters",
    component: <CopyWriters />,

    // !!savedrole_Id &&  (savedrole_Id == 1 ? <CopyWriters /> : <Navigate to="/purchase-requests" />),
  },
  {
    route: "/editors",
    component: <Editors />,
  },
  {
    route: "/notification",
    component: <Notification />,
  },
  {
    route: "/members",
    component: <Members />,
  },
  {
    route: "/clear-pending-titling",
    component: <PendingTitling />,
  },
  {
    route: "/clear-pending-publication",
    component: <PendingPublication />,
  },
  {
    route: "/release-video",
    component: <Releasevideo />,
  },
  {
    route: "/managers",
    component: <Managers />,
  },
  {
    route: "/message",
    component: <Message />,
  },
  {
    route: "/message-details/:id",
    component: <MessageDetails />,
  },
  {
    route: "/support",
    component: <Support />,
  },
  {
    route: "/support-details/:id",
    component: <MessageDetails />,
  },
  {
    route: "/release-video",
    component: <Releasevideo />,
  },
  {
    route: "/published",
    component: <Published />,
  },
  {
    route: "/pending",
    component: <Pending />,
  },
  {
    route: "/video/:id",
    component: <VideoDetailsPage />,
  },
  // {
  //   route: "/pending/:id",
  //   component: <PendingVideo />,
  // },
  {
    route: "/inquiring",
    component: <Inquiring />,
  },
  {
    route: "/approved",
    component: <Approved />,
  },
  {
    route: "/website",
    component: <Website />,
  },
  {
    route: "/duplications",
    component: <Duplications />,
  },
  {
    route: "/rejected",
    component: <Rejected />,
  },
  {
    route: "/deleted",
    component: <Deleted />,
  },
  {
    route: "/deleted/:id",
    component: <DeletedVideo />,
  },
  {
    route: "/myaccount",
    component: <Myaccount />,
  },
  {
    route: "/hubuser",
    component: <Hubuser />,
  },
  {
    route: "/qc-agents",
    component: <QcAgents />,
  },
  {
    route: "/partners",
    component: <Partner />,
  },
  {
    route: "/buyers-list",
    component: <BuyersList />,
  },
  {
    route: "/purchase-requests",
    component: <PurchaseRequest />,
  },

  {
    route: "/request-details/:id",
    component: <PurchaseRequestDetails />,
  },
];
export const managerdashboad = [
  {
    route: "/manager-dashboard",
    component: <ManagerDashboard />,
  },

  {
    route: "/manager-dashboard/myaccount",
    component: <MyAccountManager />,
  },
  {
    route: "/manager-dashboard/messages",
    component: <MyMessage />,
  },
  {
    route: "/manager-dashboard/message-details/:id",
    component: <ManagerMessageDetails />,
  },
  {
    route: "/manager-dashboard/searchresult",
    component: <ManagerSearchResult />,
  },
];
export const editordashboad = [
  {
    route: "/editor-dashboard",
    component: <EditorDashboard />,
  },
  {
    route: "/editor-dashboard/editor-search",
    component: <EditorSearchResult />,
  },
];

export const copywritersdashboad = [
  {
    route: "/user/copywriter",
    component: <CopywriterDashboard />,
  },

  {
    route: "/copywriter-dashboard/myaccount",
    component: <CopyWriterMyAccount />,
  },

  {
    route: "/copywriter-dashboard/completed-videos",
    component: <CopywriterCompleteVideos />,
  },

  {
    route: "/copywriter-dashboard/pending-titling-page",
    component: <PendingTitlingPage />,
  },

  {
    route: "/copywriter-dashboard/completed-videos",
    component: <PendingTitlingCopyWriters />,
  },

  {
    route: "/copywriter-dashboard/pending-titling/revised",
    component: <PendingTitlingRevised />,
  },

  {
    route: "/copywriter-dashboard/search-result",
    component: <CopywriterSearchResult />,
  },
];

export const QCdashboad = [
  {
    route: "/qcagent-dashboard",
    component: <QcagentDasboard />,
  },
  {
    route: "/qcagent-searchresult",
    component: <QcSearchVideoPage />,
  },
];

export const contentbuyerdashboad = [
  {
    route: "/content-buyer-dashboard",
    component: <ContentBuyerDashboard />,
  },
];

export const memberpartnerdashboad = [
  {
    route: "/memberpartner-dashboard",
    component: <MemberPartnerDashboard />,
  },
];
